import { render, staticRenderFns } from "./AllBusinessesTable.vue?vue&type=template&id=613bdf6b&scoped=true&"
import script from "./AllBusinessesTable.vue?vue&type=script&lang=ts&"
export * from "./AllBusinessesTable.vue?vue&type=script&lang=ts&"
import style0 from "./AllBusinessesTable.vue?vue&type=style&index=0&id=613bdf6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613bdf6b",
  null
  
)

export default component.exports